
<div *ngIf="question">
<div [appMath]="question.questionText" *ngIf="renderMathNow"></div>
<div class="border-gold">
<table class="table">
<tbody>
    <tr *ngFor="let choice of question.choices; index as myCount">
        <td>
             <i class="fa fa-circle-thin fa-lg" *ngIf="choice.name!='answer'"></i>
             <i class="fa fa-check-circle fa-lg text-success" *ngIf="choice.name=='answer'"></i>
             <span [innerHTML]="' '+choice.display"></span>
        </td>
    </tr>
  </tbody>
</table>
</div>

<table class="table" *ngIf="question.is_multipart!=1">
  <tbody>
    <tr>
        <td class="text-end">Answer Given:</td>
        <td class="text-start" [innerHTML]="question.answerGiven['display']"></td>
    </tr>
    <tr *ngIf="!question.is_radio_group">
        <td class="text-end">Correct Answer:</td>
        <td class="text-start" [innerHTML]="question.correctAnswer['display']"></td>
    </tr>
    <tr>
        <td class="text-end">Result:</td>
        <td class="text-start">
        <span *ngIf="question.is_correct">
            Passed (<i class="fa fa-check text-success"></i>)
        </span>
        <span *ngIf="!question.is_correct">
            Failed (<i class="fa fa-close text-danger"></i>)
        </span>
        </td>
    </tr>
  </tbody>
    </table>
    <app-revise-question-answer-description
    *ngIf="question"
    [question]="question">
  </app-revise-question-answer-description>

    <span *ngIf="question.is_multipart==1">
        <app-revise-question-prompt
        *ngFor="let prompt of question.prompts;"
        [prompt]="prompt">
        </app-revise-question-prompt>
    </span>

  </div>

